// import React, { useState } from "react";
// import axios from "axios";
// import useStore from "../store/store";
// import Snackbar from "@mui/material/Snackbar";
// import { useCookies } from "react-cookie";
// import { useAuth } from "../context/AuthProvider";
// import verifyToken from "../helpers/validateWithJWT";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import useAxiosInstance from "../helpers/useAxiosInstance";

// const SignIn = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const setUser = useStore((state) => state.setUser);
//   const [open, setOpen] = useState(false);
//   const [cookies, setCookie] = useCookies();
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();
//   const { setContext } = useAuth();

//   const axiosInstance = useAxiosInstance()

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axiosInstance.post(
//         process.env.REACT_APP_API_URL + "/auth/signin",
//         { email, password }
//       );

//       const { accessToken, refreshToken, user } = response?.data;

//       // await verifyToken(accessToken);

//       setContext({
//         accessToken,
//         user,
//       });
//       setUser(user);


//       setCookie("accessToken", accessToken, {
//         path: "/",
//         maxAge: 8 * 60 * 60, // 8 hrs
//       });

//       // setCookie("refreshToken", refreshToken, {
//       //   path: "/",
//       //   maxAge: 7 * 24 * 60 * 60, // 7 days
//       // });

//       setCookie("user", btoa(JSON.stringify(user)), {
//         path: "/",
//         maxAge: 8 * 60 * 60, // 8 hrs

//       });

//       navigate("/");
      
//     } catch (error) {
//       setTimeout(() => {
//         setOpen(false);
//       }, [4000]);
//       console.error("Sign in failed:", error?.response?.data?.error);
//       setMessage(error?.response?.data?.error);
//     }
//   };

//   return (
//     <div className="flex items-center justify-center min-h-screen min-w-[100vw] bg-white">
//       <div className="p-8 rounded-lg shadow-3d w-full max-w-sm text-center bg-white border border-gray-200">
//         <h1 className="text-4xl font-extrabold text-gray-900 mb-8">Sidekick</h1>
//         {message && (
//           <p className="text-red-500 text-sm text-center mb-4">{message}</p>
//         )}
//         <form onSubmit={handleSubmit} className="flex flex-col gap-6">
//           <input
//             type="text"
//             value={email}
//             onChange={(e) => {
//               setMessage("");
//               setEmail(e.target.value);
//             }}
//             placeholder="Email"
//             className="px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
//           />
//           <input
//             type="password"
//             value={password}
//             onChange={(e) => {
//               setMessage("");
//               setPassword(e.target.value);
//             }}
//             placeholder="Password"
//             className="px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
//           />
//           <button
//             type="submit"
//             className="px-4 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition duration-300"
//           >
//             Sign in
//           </button>
//         </form>

//         <Snackbar
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//           autoHideDuration={3000}
//           open={open}
//           message="Invalid Credentials"
//         />
//       </div>
//     </div>
//   );
// };

// export default SignIn;

import React, { useState } from "react";
import useStore from "../store/store";
import Snackbar from "@mui/material/Snackbar";
import { useCookies } from "react-cookie";
import { useAuth } from "../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import useAxiosInstance from "../helpers/useAxiosInstance";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const setUser = useStore((state) => state.setUser);
  const [open, setOpen] = useState(false);
  const [, setCookie] = useCookies();
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const { setContext } = useAuth();

  const axiosInstance = useAxiosInstance();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axiosInstance.post(
        process.env.REACT_APP_API_URL + "/auth/signin",
        { email, password },
        { withCredentials: true }
      );

      const { accessToken, user } = response?.data;

      setContext({
        accessToken,
        user,
      });

      setUser(user);

      setCookie("accessToken", accessToken, {
        path: "/",
        maxAge: 8 * 60 * 60,
      });

      // setCookie("user", btoa(JSON.stringify(user)), {
      //   path: "/",
      //   maxAge: 8 * 60 * 60,
      // });

      navigate("/");
      
    } catch (error) {
      setOpen(true);
      setTimeout(() => {
        setOpen(false);
      }, 4000);

      console.error("Sign in failed:", error?.response?.data?.error);
      setMessage(error?.response?.data?.error || "Sign in failed");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen min-w-[100vw] bg-white">
      <div className="p-8 rounded-lg shadow-3d w-full max-w-sm text-center bg-white border border-gray-200">
        <h1 className="text-4xl font-extrabold text-gray-900 mb-8">Sidekick</h1>

        {message && (
          <p className="text-red-500 text-sm text-center mb-4">{message}</p>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <input
            type="text"
            value={email}
            onChange={(e) => {
              setMessage("");
              setEmail(e.target.value);
            }}
            placeholder="Email"
            className="px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => {
              setMessage("");
              setPassword(e.target.value);
            }}
            placeholder="Password"
            className="px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
          />

          <button
            type="submit"
            className="px-4 py-3 bg-black text-white rounded-lg hover:bg-gray-800 transition duration-300"
          >
            Sign in
          </button>
        </form>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={3000}
          open={open}
          message="Invalid Credentials"
        />
      </div>
    </div>
  );
};

export default SignIn;
